import {Template} from "../shared/render/template.interface";
import {CookieManagement} from "./cookie-management.component";


export class CookieManagementTemplate implements Template {
    container: HTMLDivElement;

    constructor(
        private document: Document,
        private cookieManagement: CookieManagement
    ) {
        this.initContainer();
        this.initContent();
    }

    private initContainer(): void {
        this.container = this.document.createElement('div');
        this.container.id = 'cookie-management';
        this.container.classList.add('cookie-management-modal');
        this.container.tabIndex = -1;
    }

    private initContent(): void {
        this.container.innerHTML = `
            <div class="cookie-management-modal-dialog cookie-management-modal-step-introduction">
                <div class="cookie-management-modal-content">
                    <div class="cookie-management-modal-header">
                        <svg viewBox="0 0 48 48" fill="none" class="cookie-management-modal-header-icon"
                             xmlns="http://www.w3.org/2000/svg">
                            <path d="M24.34 4.71C13.85 4.71 5.33997 13.22 5.33997 23.71C5.33997 34.2 13.85 42.71 24.34 42.71C34.83 42.71 43.34 34.2 43.34 23.71C43.34 23.15 43.34 22.61 43.26 22.08C43.22 21.58 42.79 21.22 42.29 21.26C42.14 21.27 42 21.32 41.87 21.4C40.41 22.34 38.46 21.92 37.52 20.46C37.41 20.28 37.31 20.1 37.23 19.9C37.14 19.66 36.94 19.48 36.7 19.39C36.46 19.3 36.19 19.32 35.96 19.44C33.32 20.86 30.03 19.87 28.61 17.23C28.19 16.44 27.96 15.56 27.96 14.66C27.96 13.76 28.18 12.88 28.61 12.09C28.85 11.65 28.68 11.1 28.24 10.86C28.21 10.84 28.17 10.83 28.14 10.81C26.93 10.34 26.14 9.17 26.14 7.88C26.14 7.28 26.31 6.69 26.64 6.18C26.81 5.91 26.83 5.58 26.69 5.29C26.55 5.01 26.27 4.82 25.95 4.79C25.44 4.75 24.9 4.71 24.34 4.71Z"
                                  stroke="#003865" stroke-width="1.6" stroke-miterlimit="10"/>
                            <path d="M14.98 24.87C16.4767 24.87 17.69 23.6567 17.69 22.16C17.69 20.6633 16.4767 19.45 14.98 19.45C13.4833 19.45 12.27 20.6633 12.27 22.16C12.27 23.6567 13.4833 24.87 14.98 24.87Z"
                                  fill="#003865"/>
                            <path d="M29.46 34.83C30.9567 34.83 32.17 33.6167 32.17 32.12C32.17 30.6233 30.9567 29.41 29.46 29.41C27.9633 29.41 26.75 30.6233 26.75 32.12C26.75 33.6167 27.9633 34.83 29.46 34.83Z"
                                  fill="#003865"/>
                            <path d="M24.03 25.78C25.0296 25.78 25.84 24.9696 25.84 23.97C25.84 22.9704 25.0296 22.16 24.03 22.16C23.0303 22.16 22.22 22.9704 22.22 23.97C22.22 24.9696 23.0303 25.78 24.03 25.78Z"
                                  fill="#003865"/>
                            <path d="M21.32 17.19C22.0711 17.19 22.68 16.5811 22.68 15.83C22.68 15.0789 22.0711 14.47 21.32 14.47C20.5689 14.47 19.96 15.0789 19.96 15.83C19.96 16.5811 20.5689 17.19 21.32 17.19Z"
                                  fill="#003865"/>
                            <path d="M18.11 30.76C18.11 31.235 17.725 31.62 17.25 31.62C16.775 31.62 16.39 31.235 16.39 30.76C16.39 30.285 16.775 29.9 17.25 29.9C17.725 29.9 18.11 30.285 18.11 30.76Z"
                                  stroke="#003865"/>
                            <path d="M35.79 8.59C36.7896 8.59 37.6 7.77964 37.6 6.78C37.6 5.78036 36.7896 4.97 35.79 4.97C34.7903 4.97 33.98 5.78036 33.98 6.78C33.98 7.77964 34.7903 8.59 35.79 8.59Z"
                                  fill="#003865"/>
                            <path d="M34.44 14.93C35.1911 14.93 35.8 14.3211 35.8 13.57C35.8 12.8189 35.1911 12.21 34.44 12.21C33.6888 12.21 33.08 12.8189 33.08 13.57C33.08 14.3211 33.6888 14.93 34.44 14.93Z"
                                  fill="#003865"/>
                            <path d="M41.68 15.37C42.1771 15.37 42.58 14.9671 42.58 14.47C42.58 13.9729 42.1771 13.57 41.68 13.57C41.183 13.57 40.78 13.9729 40.78 14.47C40.78 14.9671 41.183 15.37 41.68 15.37Z"
                                  fill="#003865"/>
                        </svg>
        
                        <h5 class="cookie-management-modal-header-title">
                           ${this.cookieManagement.getResource('cookies.we-use-cookies')}
                        </h5>
                    </div>
                    <div class="cookie-management-modal-body">
                        <p class="cookie-management-modal-body-pre-title">
                            ${this.cookieManagement.getResource('cookies.pre-title-text')}
                        </p>
                        <h6 class="cookie-management-modal-body-title">
                            ${this.cookieManagement.getResource('cookies.usage')}
                        </h6>
                        <ul class="cookie-management-modal-body-list">
                            ${this.cookieManagement.getResource('cookies.usage-list')}
                        </ul>
                    </div>
                    <div class="cookie-management-modal-footer">
                        <div class="cookie-management-button-group">
                            <button type="button" class="btn cookie-management-modal-action-button cookie-management-accept btn-primary">
                                    ${this.cookieManagement.getResource('cookies.accept-all')}
                            </button>
                            <button type="button" class="btn cookie-management-modal-action-button cookie-management-edit btn-primary">
                                ${this.cookieManagement.getResource('cookies.customize')}
                            </button>
                        </div>
                        <button type="button" class="btn cookie-management-modal-action-button cookie-management-deny btn-primary deny-btn">
                            ${this.cookieManagement.getResource('cookies.deny-all')}
                        </button>
                        <p class="cookie-management-modal-footer-description">
                            ${this.cookieManagement.getResource('cookies.description')}
                        </p>
                    </div>
                </div>
            </div>
        
            <div class="cookie-management-modal-dialog cookie-management-modal-step-selection">
                <div class="cookie-management-modal-content">
                    <div class="cookie-management-modal-header">
                        <!--TODO: move arrow icon into sprite-->
                        <svg viewBox="0 0 16 16" fill="none"
                             class="cookie-management-modal-header-icon icon-smaller icon-action cookie-management-previous"
                             xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd"
                                  d="M16 8.75H2.87L9.06 14.94L8 16L0 8L8 0L9.06 1.06L2.87 7.25H16V8.75Z" fill="#0099CC"/>
                        </svg>
        
                        <h5 class="cookie-management-modal-header-title smaller">
                            ${this.cookieManagement.getResource('cookies.setup')}
                        </h5>
                    </div>
                    <form class="cookie-management-settings-form">
                        <div class="modal-body cookie-management-modal-body">
                            <label class="cookie-management-modal-body-input">
                                <span class="cookie-management-input-name">
                                    ${this.cookieManagement.getResource('cookies.technical')}
                                </span>
                                <span class="switch-input cookie-management-switch-input">
                                    <input type="checkbox" class="cookie-management-input-technical" name="technical" value="on"
                                           checked="checked" disabled>
                                    <span class="switch-input-slider"></span>
                                </span>
                            </label>
                            <p class="cookie-management-modal-body-input-description">
                                ${this.cookieManagement.getResource('cookies.technical-description')}
                            </p>
                            <label class="cookie-management-modal-body-input">
                                <span class="cookie-management-input-name">
                                    ${this.cookieManagement.getResource('cookies.analytical')}
                                </span>
                                <span class="switch-input cookie-management-switch-input">
                                    <input type="checkbox" class="cookie-management-input-analytics" name="analytics">
                                    <span class="switch-input-slider"></span>
                                </span>
                            </label>
                            <p class="cookie-management-modal-body-input-description">
                                ${this.cookieManagement.getResource('cookies.analytical-description')}
                            </p>
                            <label class="cookie-management-modal-body-input">
                                <span class="cookie-management-input-name">
                                    ${this.cookieManagement.getResource('cookies.marketing')}
                                </span>
                                <span class="switch-input cookie-management-switch-input">
                                    <input type="checkbox" class="cookie-management-input-marketing" name="marketing">
                                    <span class="switch-input-slider"></span>
                                </span>
                            </label>
                            <p class="cookie-management-modal-body-input-description">
                                ${this.cookieManagement.getResource('cookies.marketing-description')}
                            </p>
                        </div>
                        <div class="cookie-management-modal-footer">
                            <button type="submit" class="btn cookie-management-modal-action-button btn-primary">
                                ${this.cookieManagement.getResource('cookies.confirm')}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        `;
    }
}